module.exports = __webpack_public_path__ + "static/media/longBreak.aaeff077.svg";